export enum LoggerActionList {
  LOG = '[Logger] Log',
  LOG_FAIL = '[Logger] Log fail'
}
